import { PayloadAction } from '@reduxjs/toolkit';
import { call } from 'redux-saga/effects';
import { ActiveMediaDevicePayload } from 'features/user-media/types';
import { RTCClient } from 'utils/webrtc';

export function* changeStreamingDeviceSaga(action: PayloadAction<ActiveMediaDevicePayload>) {
  if (action.payload.kind === 'audioinput') {
    yield call(RTCClient.publishingFeed.changeAudioDevice, action.payload);
  }

  if (action.payload.kind === 'videoinput') {
    yield call(RTCClient.publishingFeed.changeVideoDevice, action.payload);
  }
}
